"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

require("./notification.scss");

var _inlineNotification = _interopRequireDefault(require("./inlineNotification"));

var NotificationWithCallToAction = function NotificationWithCallToAction(_ref) {
  var onAction = _ref.onAction,
      actionText = _ref.actionText,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["onAction", "actionText", "children"]);
  return /*#__PURE__*/_react["default"].createElement(_inlineNotification["default"], rest, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-inline-notification--call-to-action"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-inline-notification--call-to-action-children"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-inline-notification--call-to-action-button",
    onClick: onAction
  }, actionText)));
};

var _default = NotificationWithCallToAction;
exports["default"] = _default;